import * as React from 'react';
import discardSurfaceActionsOption from './actions/discardSurfaceActionsOption';
import isSurfaceActionsOptionDirty from './utils/isSurfaceActionsOptionDirty';
import MailSurfaceActions from './components/MailSurfaceActions';
import saveSurfaceActionsOption from './actions/saveSurfaceActionsOption';
import { SurfaceType } from 'owa-surface-actions-view';
import { isFeatureEnabled } from 'owa-feature-flags';
import { Option } from 'owa-options-core';

let HoverSurfaceActionsOption: Option = {
    key: 'hoverSurfaceActions',
    titleStringKey: 'optionTitle_hoverSurfaceActions',
    searchTermsStringKey: 'optionTitle_hoverSurfaceActions',
    fullOptionFormSettings: {
        render: () => <MailSurfaceActions surfaceType={SurfaceType.Hover} />,
        isDirty: isSurfaceActionsOptionDirty,
        onSave: saveSurfaceActionsOption,
        onDiscard: discardSurfaceActionsOption,
    },
    isHidden: () => !isFeatureEnabled('tri-customHoverActions'),
    allowedOptionKeys: ['MailQuickActions'],
};

export default HoverSurfaceActionsOption;
